var exports = {
  "Nr": "CrosspostCommunityCard.module__card___TVk4TG",
  "Uo": "CrosspostCommunityCard.module__sheetCard___TVk4TG",
  "vK": "CrosspostCommunityCard.module__banner___TVk4TG",
  "_e": "CrosspostCommunityCard.module__bannerImage___TVk4TG",
  "Dw": "CrosspostCommunityCard.module__bannerScrim___TVk4TG",
  "Kk": "CrosspostCommunityCard.module__icon___TVk4TG",
  "rf": "CrosspostCommunityCard.module__body___TVk4TG",
  "$": "CrosspostCommunityCard.module__titleRow___TVk4TG",
  "fh": "CrosspostCommunityCard.module__nameText___TVk4TG",
  "h_": "CrosspostCommunityCard.module__description___TVk4TG",
  "qr": "CrosspostCommunityCard.module__footer___TVk4TG",
  "dJ": "CrosspostCommunityCard.module__stat___TVk4TG",
  "gW": "CrosspostCommunityCard.module__statDot___TVk4TG",
  "rR": "CrosspostCommunityCard.module__statDotOnline___TVk4TG" + " " + "CrosspostCommunityCard.module__statDot___TVk4TG",
  "rb": "CrosspostCommunityCard.module__statDotMembers___TVk4TG" + " " + "CrosspostCommunityCard.module__statDot___TVk4TG",
  "KA": "CrosspostCommunityCard.module__statText___TVk4TG",
  "lm": "CrosspostCommunityCard.module__notice___TVk4TG",
  "XI": "CrosspostCommunityCard.module__action___TVk4TG",
  "Lq": "CrosspostCommunityCard.module__loading___TVk4TG",
};

module.exports = exports;
